import { Component, OnDestroy, OnInit } from '@angular/core';
import { RightPanelService } from '../core/services/right-panel.service';
import { TicketRightPanelService } from '../core/services/ticket-right-panel.service';
import { TicketDetailsPanelService } from '../core/services/ticket-details-panel.service';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { NgClass } from '@angular/common';
import { TicketDetailsComponent } from '../ticket-details/ticket-details.component';
import { RightPanelComponent } from '../right-panel/right-panel.component';
import { ModalModule } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-single-ticket',
    templateUrl: './single-ticket.component.html',
    styleUrls: ['./single-ticket.component.scss'],
    imports: [NgClass, TicketDetailsComponent, RightPanelComponent, ModalModule],
})
export class SingleTicketComponent implements OnInit, OnDestroy {
    private unsubscriber = new Subject<void>();

    constructor(
        public rightPanelService: RightPanelService,
        public ticketRightPanelService: TicketRightPanelService,
        public ticketDetailsPanelService: TicketDetailsPanelService,
        private activatedRoute: ActivatedRoute,
    ) {
        this.setMinWidthToBody();
    }

    ngOnInit() {
        this.activatedRoute.queryParams.pipe(takeUntil(this.unsubscriber)).subscribe((params) => {
            this.ticketDetailsPanelService.open(params.ticketId);
        });
    }

    private setMinWidthToBody() {
        document.body.style.minWidth = '500px';
    }

    ngOnDestroy() {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
